import { canUseDOM } from "exenv-es6";
/*
 * Check for backdrop-filter support within the current browser
 */
export const backdropFilterSupport = canUseDOM() &&
    ("backdrop-filter" in document.documentElement.style ||
        "-webkit-backdrop-filter" in document.documentElement.style);
/*
 * Applies a partially transparent "acrylic" background to an element
 */
export function applyAcrylic(config) {
    const backdropFilterStyles = {
        background: config.backgroundColor,
        "-webkit-backdrop-filter": `blur(${config.blurRadius ||
            "30px"}) saturate(${config.saturation || "125%"})`,
        "backdrop-filter": `blur(${config.blurRadius ||
            "30px"}) saturate(${config.saturation || "125%"})`,
    };
    const fallbackStyles = {
        background: config.fallbackBackgroundColor,
    };
    const styles = backdropFilterSupport
        ? backdropFilterStyles
        : fallbackStyles;
    return Object.assign({}, styles, { "&::before": {
            content: '""',
            background: config.textureImage
                ? `url(${config.textureImage}) repeat`
                : undefined,
            position: "absolute",
            top: "0",
            bottom: "0",
            left: "0",
            right: "0",
            opacity: ".02",
            "pointer-events": "none",
        } });
}
